module.exports = __webpack_public_path__ + "static/media/whatsapp-btn.5777e5f4.png";